<template>
<div v-if="performance">
    <div class="share-card-panel" v-if="routers">
        <b-row>
            <b-col cols="12" md="12">
                <div class="share-panel-header">
                    <div class="share-panel-header-title">{{ user.firstName }} -  
                        <b-form-select v-if="edit" name="sports" id="sports" v-validate="'required'" v-model="sport" class="cust-input custom-drop-down">
                            <b-form-select-option v-for="(sport,id) in sports" :key="id" :value="sport.name">{{ $t('sports.'+sport.name) }}</b-form-select-option>
                        </b-form-select>
                        <div v-else>{{ $t('sports.'+performance.sport) }}</div>
                    </div>
                    <div class="share-panel-header-icon">
                        <v-icon v-if="!edit" class="header-panel-img" name="edit" @click="toggleEdit"/>
                        <v-icon v-else class="header-panel-img" name="save" @click="toggleEdit"/>
                        <v-icon class="header-panel-img" @click="deleteRecord" name="trash-alt"/>
                        <!-- <router-link :to="{ name: 'performancesShare', params: { Id : this.$route.params.Id }}">
                            <v-icon class="header-panel-img" name="share-alt"/>
                        </router-link> -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="right-brd">
                <div class="share-panel-lo-block">
                    <b-avatar class="panel-avtar" variant="info" :src="profilePicture"></b-avatar>
                    <div class="share-panel-lo-text-lg">
                        <b-form-input ref="perfoNameInput" v-if="edit" type="text" class="cust-input" v-model="name"></b-form-input>
                        <div v-else class="share-panel-lo-text-lg">{{performance.name}}</div>
                    </div>
                    <div class="share-panel-lo-text">
                        <img class="lo-panel-img" :src="require('@/assets/img/pageicon/addr-icon.png')" />
                        <datetime v-if="edit" type="datetime" v-model="date"></datetime>
                        <div v-else>{{ performance.date | moment("dddd Do MMMM YYYY") }}</div>
                    </div>
                    <div v-if="!edit" class="share-panel-lo-text">
                        <v-icon class="lo-panel-img" name="clock"></v-icon> 
                        <div>{{ performance.date | moment("HH:mm:ss") }}</div>
                    </div>
                    <div class="share-panel-lo-text">
                        <img class="lo-panel-img" :src="require('@/assets/img/pageicon/location-icon.png')" /> 
                        <b-form-input v-if="edit" type="text" class="cust-input" v-model="place"></b-form-input>
                        <div v-else>{{ performance.place }}</div>
                    </div>
                </div>

                <div class="border-btm"></div>

                <div class="share-panel-description">
                    <label for="exploit-description">{{ $t('global.description') }}</label>
                    <b-form-textarea id="exploit-description" class="ExploitDescriptionNoEdit" v-model="description" rows="3" max-rows="6" :readonly="!edit"></b-form-textarea>
                </div>

                <div class="border-btm"></div>

                <div class="share-panel-btm">
                    <!-- <v-icon name="exclamation" scale="2" /> -->
                    <b-icon class="icon-all" icon="exclamation-triangle"></b-icon>
                    <div class="share-panel-btm-war">
                        <p v-html="$t('performances.main.help')"></p>
                    </div>
                    <a href="mailto:gregoire@spomo.io">
                      <b-icon class="icon-all" icon="envelope">
                      </b-icon>
                    </a>
                    <!-- <a href="mailto:gregoire@spomo.io"><v-icon name="at" scale="2" /></a> -->
                </div>
                
                <div class="vertical-border-btm"></div>
            </b-col>
            <b-col cols="12" md="6">
                <div class="info-row" v-if="summary.distance != '-'">
                    <div class="info-col">
                        <div class="info-title">{{ summary.distance | units('m','km',true) | truncate(2) }}</div>
                        <div class="info-number">{{ $t('global.distance') }}</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">{{ durationFormatter(summary.duration) }}</div>
                        <div class="info-number">{{ $t('global.duration') }}</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">{{ summary.meanSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                        <div class="info-number">{{ $t('performances.main.meanSpeed') }}</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">{{ summary.maxSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                        <div class="info-number">{{ $t('performances.main.maxSpeed') }}</div>
                    </div>
                </div>
                <div class="info-row" v-else>
                    <PulseLoader class="center-block-middle" :size="10"></PulseLoader>
                </div>

                <!-- <div class="info-row">
                    <div class="info-col">
                        <div class="info-title">To do</div>
                        <div class="info-number">Meilleur 10 sec..</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">To do</div>
                        <div class="info-number">Meilleur 2sec..</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">To do</div>
                        <div class="info-number">Meilleur 100 m</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">To do</div>
                        <div class="info-number">Meilleur 250 m</div>
                    </div>
                </div> -->

                <meteo-control :meteo="this.meteo" :edit="edit" ></meteo-control>

                <div class="border-btm" style="margin-left: 0"></div>
                
            </b-col>
        </b-row>
    </div>

    <!-- <h2>Performance editor</h2>
    <h3>{{performances.name}}</h3>
    <div>{{ performances.date | moment("DD/MM/YYYY, kk:mm:ss") }}</div> -->
    <router-view></router-view>

    <!-- <b-modal id="modal-delete" hide-footer centered title="Supprimer mom exploit">
        <div class="cust-body">
            <div class="modal-text">{{ $t('performances.main.deleteMessage') }}</div>
        </div>
        <div class="btm-modal-block">
            <b-button type="button" class="btm-modal-btn-ui-gray" @click="deleteRecord">
                <div class="mes-exp">
                    Supprimer <br /> mon exploit
                </div>
            </b-button>
            <b-button type="button" class="btm-modal-btn-ui-blue" @click="$bvModal.hide('modal-delete')">
                <img class="toxins-img" :src="require('@/assets/img/pageicon/six.png')" />
                <div class="mes-exp">
                    Finalement <br /> je le conserve
                </div>
            </b-button>
        </div>
    </b-modal> -->
</div>
</template>

<script>

import MeteoControl from '@/components/Meteo/MeteoControl';

export default {
    data() {
        return {
            edit:false,
            name:'',
            date:'',
            time:'',
            place:'',
            sport:'',
            description:'',
            summary : {
                distance : '-',
                duration : '-',
                meanSpeed : '-',
                maxSpeed : '-'
            },
            meteo :{
                windSpeed : 0,
                windDirection : 0,
                weather : 'Sunny',
                skyCover : 'Clear' 
            }
        }
    },
    components:{MeteoControl},
    computed: {
        routers() {
            return this.$route.meta.layout;
        },
        user() {
            return this.$store.getters['Auth/user'];
        },
        profilePicture(){
            const storeUser = this.$store.getters['Auth/user'];
            if(storeUser != null && storeUser.photo != null){
                return storeUser.photo;
            }else{
                return 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm';
            }
        },
        sports() {
            return this.$store.getters['Performances/sports']
        },
        performance() {
            return this.$store.getters['Performances/edit'];          
        }
    },
    async created() {

        const Id = this.$route.params.Id

        try {

            this.$store.dispatch('Performances/getSport')
                .then(() => {})
                .catch((error) => { this.$store.dispatch('errors', {error: error }) });

            await this.$store.dispatch('Performances/fetchData',Id);
            
            this.name = this.performance.name;
            this.description = this.performance.description;
            this.date = this.performance.date;
            this.place = this.performance.place;
            this.meteo = this.performance.meteo;
            this.sport = this.performance.sport;
            this.description = this.performance.description;

            this.$store.dispatch('Performances/summaryData',Id)
                .then(()=>{
                    if(this.performance.summary != null){
                        this.summary.distance = this.performance.summary.distance;
                        this.summary.duration = this.$moment.duration(this.$moment(this.performance.summary.date.end).diff(this.performance.summary.date.start));
                        this.summary.meanSpeed = this.performance.summary.speed.mean;
                        this.summary.maxSpeed = this.performance.summary.speed.max;
                    }
                })
                .catch((error) => {
                    this.$store.dispatch('errors', {
                        error: error
                    })
                });

        } catch (error) {
            
        }
    },
    methods: {
        toggleEdit(){
            if(this.edit){
                this.updateRecord();
            }

            this.edit=!this.edit;
        },
        dateFormatter(date){
            return this.$moment(date).format("YYYY-MM-DD");
        },
        timeFormatter(date){
            return this.$moment(date).format('HH:mm:ss');
        },
        durationFormatter(duration){
            return this.$moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
        },
        async updateRecord(){
            try {
                const newPerfoValues = {
                    name : this.name,
                    description : this.description,
                    date : this.date,
                    place : this.place,
                    meteo : this.meteo,
                    sport : this.sport,
                    description : this.description,
                    meteo : this.meteo
                };

                const params = {
                    performandeId:this.performance.id,
                    performaceValues:newPerfoValues
                };

                await this.$store.dispatch('Performances/updatePerformance',params)
                
            } catch (error) {
                this.$store.dispatch('errors',{error: error});
            }
        },
        deleteRecord(){
            const Id = this.$route.params.Id

            this.$bvModal.msgBoxConfirm(this.$t('performances.delete.deleteMessage'), {
                    title: this.$t('performances.delete.deleteTitle'),
                    bodyClass:'modal-text',
                    okTitle:this.$t('performances.delete.deleteConfirm'),
                    cancelTitle:this.$t('performances.delete.deleteCancel'),
                    okVariant: 'success',
                    centered: true
                })
                .then(value => {
                    if(value === true){
                        this.$store.dispatch('Performances/deleteData', Id)
                            .then(() => {
                                this.$router.push({ name: 'performances' });
                            })
                            .catch((error) => {
                                this.$store.dispatch('error',error);
                            });
                    }
                })
                .catch(err => {
                    this.$store.dispatch('error',error);
                });


            // this.$store.dispatch('Performances/deleteData',Id)
            //     .then(() => {
            //         this.$router.push({ name: 'performances' });
            //     })
            //     .catch((error) => {
            //         this.$store.dispatch('errors', { error: error });
            //     });
        },
        
    }
};
</script>

<style>
  @import "../style/components/layout/Performances.scss";
</style>
